import { DashboardMenuItem } from "../../../frame/dashboard-frame-config";


export const ideasAndBugsMenu: DashboardMenuItem = {
	label: 'Ideas and Bugs',
	icon: 'fa-light fa-comment',

	subMenu: [
		{
			label: 'Share an Idea...',
			url: 'https://accounts.google.com/AccountChooser?continue=https://chat.google.com/room/AAAAPgbQXfw',
			target: 'chat',
			icon: 'fa-light fa-comments',
		},
		{
			label: 'Report a Bug...',
			url: 'https://accounts.google.com/AccountChooser?continue=https://chat.google.com/room/AAAAlOvAAAc',
			target: 'chat',
			icon: 'fa-light fa-bug',
		},
	]
};